import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";
import { ReactComponent as LeftChevron } from "../../../assets/left-chevron-icon.svg"
import { getDateAndMonth } from "../../../utils/helpers/epoch";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../../constant";

interface HistoryCardProps {
  timestampForDateLabel?: any;
  tournamentTitle?: string;
  tournamentTimings?: string;
  entriesText?: string;
  tag?: string;
  ltid: string;
}

const GameHistoryCard: React.FC<HistoryCardProps> = ({ timestampForDateLabel, tournamentTitle, tournamentTimings, entriesText, tag, ltid }) => {
  const navigate = useNavigate();
  const [tagclass,settagclass] = useState("");
  const [tournamentdate,settournametdate]=useState('');
  const getTagClass =()=> {
    if(tag==="LIVE")return "successTag";
    else if(tag==="REFUNDED")return "refundTag"
    else if(tag)return "secondaryTag"
    else return ''
  }
  const Class=getTagClass();
  const getdate=getDateAndMonth(timestampForDateLabel);
  const link = `${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/leaderboard?gameName=${'ludonx'}&ltid=${ltid}`
 
  useEffect(()=>{
    settagclass(Class);
    settournametdate(getdate)
  },[Class,getdate]);
  return (
    <>
      <div className={clsx(styles.historyCard, `${tagclass}-card`)} onClick={() => navigate(link)}>
        <div className={clsx(styles.contentBox, "contentBox")}>
          <div className={clsx(styles.dateBox, "dateBox")}>
            {timestampForDateLabel && <div className={clsx(styles.date, "fontSizeXs fontWeightBold fontColor333")}>{tournamentdate}</div>}
          </div>
          <div className={clsx(styles.detailsBox, "detailsBox")}>
            {tournamentTitle && <div className={clsx(styles.tournamentTitle, "fontSizeSm fontWeightBold")}>{tournamentTitle}</div>}
            {tournamentTimings && <div className={clsx(styles.tournamentTimings, "fontSizeSm12 fontWeightRegular fontColor959595")}>{tournamentTimings}</div>}
          </div>
          <div className={clsx(styles.navigationIconBox, "rotate180")}>
            <LeftChevron />
          </div>
        </div>
        <div className={clsx(styles.entryCountRow)}>
          {entriesText && <div className={clsx(styles.entriesCount, "fontSizeSm12 fontWeightBold fontColor333 entriesCount")}>{entriesText}</div>}
          {tag && <div className={clsx(styles.tag, `${tagclass}`, "fontSizeXs fontWeightBold fontColorWhite")}>{tag}</div>}
        </div>
      </div>
    </>
  )
}
export default GameHistoryCard;
